import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Spin, Space, Form } from 'antd';

import { ModelForm } from './Form';
import { Details } from './Details';
import { ErrorModal } from '../../../Modals/ErrorModal';
import { SuccessModal } from '../../../Modals/SuccessModal';
import { useGetDataExtractionModel } from '@/hooks/useGetDataExtractionModel';
import { BaseModal } from '@/components/Settings/DataExtraction/Modals/shared/BaseModal';
import { Title } from '@/components/Settings/DataExtraction/ExtractionType/Model/styles';
import { useConfirmationModalModel } from '@/components/Settings/DataExtraction/Content/hooks/useConfirmationModalModel';
import { GhostButton, PrimaryButton } from '@/components/ui/Button';
import { CustomForm } from './Form/styles';

interface ExtractionModelDetailsModalProps {
	visible?: boolean;
	modelId: string;
	organizationId: string;
	companyId: string;
	onCancel: () => void;
}

const { useForm } = Form;

export function ExtractionModelDetailsModal({
	visible = false,
	modelId,
	organizationId,
	companyId,
	onCancel
}: Readonly<ExtractionModelDetailsModalProps>): JSX.Element {
	const [form] = useForm();

	const { isLoading, data: modelData } = useGetDataExtractionModel({
		data_extraction_model_id: modelId,
		organization_id: organizationId,
		company_id: companyId
	});

	const {
		showSuccessModal,
		showErrorModal,
		handleConfirm,
		handleSuccessModalClose,
		handleErrorModalClose,
		handleGoToHome
	} = useConfirmationModalModel({ form, modelId, onCancel });

	const Footer = (): JSX.Element => (
		<Row justify="center" gutter={16}>
			<Col>
				<GhostButton key="cancel" onClick={onCancel}>
					{I18n.get('Cancel')}
				</GhostButton>
			</Col>
			<Col>
				<PrimaryButton type="primary" onClick={handleConfirm}>
					{I18n.get('Use template')}
				</PrimaryButton>
			</Col>
		</Row>
	);

	return (
		<>
			<BaseModal
				width={700}
				visible={visible}
				footer={<Footer />}
				onCancel={onCancel}
				title={<Title>{modelData?.model_name}</Title>}
			>
				{isLoading ? (
					<Spin />
				) : (
					modelData && (
						<CustomForm form={form} initialValues={modelData}>
							<Space size={24} direction="vertical">
								<ModelForm />
								<Details modelDetails={modelData} />
							</Space>
						</CustomForm>
					)
				)}
			</BaseModal>
			<SuccessModal
				visible={showSuccessModal}
				onCancel={handleSuccessModalClose}
				extractionName={modelData?.model_name}
				onGoToHome={handleGoToHome}
			/>
			<ErrorModal
				visible={showErrorModal}
				onCancel={handleErrorModalClose}
				extractionName={modelData?.model_name}
			/>
		</>
	);
}
